import { BrokerageOfferingPostResponse } from '@lio/api-types';
import { useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateBrokerageOffering = (brokerageId: string) => {
  const client = useClient();
  const mutationFn = ({
    offeringId,
    effectiveOn,
    effectiveThrough,
    jurisdictionId,
  }: {
    offeringId: string;
    effectiveOn?: Date;
    effectiveThrough?: Date;
    jurisdictionId?: string;
  }) =>
    client
      .patch(`brokerage/${brokerageId}/brokerage-offering/${offeringId}`, {
        json: { effectiveOn, effectiveThrough, jurisdictionId },
      })
      .json<BrokerageOfferingPostResponse>();

  const result = useMutation({ mutationFn });

  return { ...result, updateBrokerageOffering: result.mutateAsync };
};
